import { Box, Paper, Typography } from '@mui/material'
import { useNavigate, useParams } from 'react-router-dom'
import { fontWeights, sxPresets } from '@/theme'
import DuplicateIcon from '@/components/ui/icons/DuplicateIcon'

export default function PotentialDuplicateCard({ tab }: { tab: 'merge' | 'link' }) {
  const navigate = useNavigate()

  const { hash } = useParams<{ hash: string }>()

  const handleClick = () => {
    if (hash) {
      navigate(`/deduplication?patientHash=${hash}&tab=${tab}`)
    }
  }

  return (
    <Paper
      elevation={1}
      sx={{
        ...sxPresets().card.highlighted,
        cursor: 'pointer'
      }}
      onClick={handleClick}
    >
      <Box sx={{ display: 'flex', alignItems: 'flex-start', flexDirection: 'column', gap: 2, p: 2.5 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 1 }}>
          <DuplicateIcon size={32} iconSize={20} />
          <Typography variant='fieldValue' sx={{ fontWeight: fontWeights.semibold }}>
            Potential duplicate
          </Typography>
        </Box>
      </Box>
    </Paper>
  )
}
